import { InjectionToken } from '@angular/core';
import { IProcedureService } from './procedure-service.interface';

export const PROCEDURE_SERVICE = new InjectionToken<IProcedureService>(
  'PROCEDURE_SERVICE'
);
